import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AdminRoute from "./AdminRoute";
import AuthenticatedRoute from "./AuthenticatedRoute";
import Layout from "./Layout/Layout";

// Lazy load the components
const Dashboard = lazy(() => import("./Pages/Dashboard"));
const Home = lazy(() => import("./Pages/Home"));
const ViewSource = lazy(() => import("./Pages/ViewSource"));
const ViewExternalSource = lazy(() => import("./Pages/ViewExternalSource"));
const Skills = lazy(() => import("./Pages/Skills"));
const NewChatFromThought = lazy(() => import("./Pages/NewChatFromThought"));
const EmbeddedSkillRedirect = lazy(() => import("./Pages/EmbeddedSkillRedirect"));
const SkillDocSummaryAssistant = lazy(() => import("./Pages/SkillDocSummaryAssistant"));
const SkillEntry = lazy(() => import("./Pages/SkillEntry"));
const ExternalAppBot = lazy(() => import("./Pages/ExternalAppBot"));
const SkillRedirect = lazy(() => import("./Pages/SkillRedirect"));
const AuditAdvisorAssistant = lazy(() => import("./Pages/AuditAdvisorAssistant"));
const AdminPanel = lazy(() => import("./Pages/Admin/AdminPanel"));

const InvalidChatRoute = lazy(() => import("./Pages/InvalidChatRoute"));

const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/chat/:guid",
    component: Dashboard,
  },
  {
    path: "/chat/:guid/:chatId",
    component: Dashboard,
  },
  {
    path: "/chat",
    component: InvalidChatRoute,
  },
  {
    path: "/view/index/:searchIndexId/source/:sourceDocumentId/page/:pageNumber",
    component: ViewSource,
  },
  {
    path: "/view/index/:searchIndexId/attachment/:sourceDocumentId/page/:pageNumber",
    component: ViewExternalSource,
  },
  { path: "/skills", component: Skills },
  { path: "/newchat", component: NewChatFromThought },
  { path: "/new/:skillName", component: EmbeddedSkillRedirect },
  { path: "/new/:skillName/embedding", component: EmbeddedSkillRedirect },
  { path: "/new/:skillName/embedding/*", component: EmbeddedSkillRedirect },
  { path: "/app/:code", component: SkillRedirect },
  { path: "/app/:code/:conversationId", component: SkillEntry },
  { path: "/app/:code/:conversationId/:engagementId", component: SkillEntry },
  { path: "/app/:code/:conversationId/:engagementId", component: SkillEntry },
  { path: "/app/:code/:conversationId", component: SkillEntry },
  { path: "/audit-assistant", component: AuditAdvisorAssistant },
  { path: "/admin", component: AdminPanel },
  {
    path: "*",
    component: InvalidChatRoute,
  },
];

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {routes.map(({ path, component: Component }, index) => {
          const isAdminPath = path.startsWith("/admin");
          const element = (
            <Suspense>
              <Component />
            </Suspense>
          );
          return (
            <Route
              key={`${index}-${Component.name}}`}
              path={path}
              element={
                <AuthenticatedRoute>
                  {isAdminPath ? <AdminRoute>{element}</AdminRoute> : element}
                </AuthenticatedRoute>
              }
            />
          );
        })}
      </Route>
    </Routes>
  );
};
